<template>
    <div class=" w100 pt20 pb20 bg-w display-box subject">
        <div class="module-items w120 mc pt20 pb20">
            <draggable
                    :value="subData"
                    animation="300"
                    class="tab-draggable"
            >
                <div class="centerDL" >
                    <div class="w100 font-24 tx-c dl-left">应用中心  <span style="color: #98adc3;font-size: 12px">/Application</span></div>
                    <el-row style="display: flex;align-items: center">
                        <el-col :span="24">
                                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                                    <el-tab-pane v-for="(e, i) in subData" :label="e.label" :key="i" :name="e.value"></el-tab-pane>
                                </el-tabs>
                        </el-col>
                    </el-row>
                    <div class="dl-more">
                        <!--<p @click="goManage"> 管理<i class="el-icon-setting"></i></p>-->
                        <p @click="tranClick(false)">收起<i :class="iconStr"></i></p>
                    </div>
                </div>
            </draggable>
            <template v-if=" dataShow" class="contClas">
                <draggable
                        :value="itemData"
                        animation="300"
                        class="module-draggable"
                        v-loading="tableLoading" :style="{'height': tableLoading ? '140px' : ''}"
                >
                    <div class="serve-item" v-for="(e, i) in itemData" :key="i" >
                        <div class="serve-logo" @click="goServe(e)">
                            <img :src="e.imageUrl" alt="">
                        </div>
                        <div class="serve-name ellipsis">{{e.name}}</div>
                    </div>
                    <!--<div class="serve-item" v-if="itemData >8">-->
                        <!--<div class="serve-logo">-->
                            <!--<img :src="`${baseUrl}images/more.png`" alt="">-->
                        <!--</div>-->
                        <!--<div class="serve-name ellipsis">更多</div>-->
                    <!--</div>-->
                    <!--<div class="more" @click="goManage">查看更多</div>-->
                </draggable>
            </template>
            <div class="arrRight" v-else>
                <i class="el-icon-d-arrow-right" @click="tranClick(true)"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import { mapGetters, mapActions } from "vuex";
    import {getSubjectDlList} from '@/api/managementCenter/specialManage'
    import { remote } from '@/api/admin/dict';
    export default {
        name: "SUBJECTDL",
        components: { draggable },
        props: ['childModules'],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                tableLoading: false,
                subjectData: {},
                subData:[],
                itemData:[],
                activeName:'',
                dataShow: true,
                iconStr: 'el-icon-arrow-down'
            };
        },
        created(){
            let subject = this.moduleList.find((item) => {
                return item.cardType === 'SUBJECT'
            })
            if(subject){
                this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
            }else {
                this.subjectData = this.childModules;
            }
        },
        computed: {
            ...mapGetters(['moduleList']),
        },
        mounted(){
            this.getSelData()
        },
        methods: {
            //获取类型
            getSelData(){
                remote('navlink_list').then(({data})=>{
                    if(data.code == 0){
                        this.subData = data.data||[];
                        this.activeName = data.data[0].value||[];
                        this.handleClick()
                    }else{
                        this.$message.warning( data.msg|| "获取类型失败!" );
                    }
                }).catch(err=>{
                    this.$message.error( err.msg|| "获取类型异常!" );
                })
            },
            tranClick(blo){
                if(blo){
                    this.dataShow = true
                    this.iconStr = 'el-icon-arrow-down'
                }else {
                    this.dataShow = false
                    this.iconStr = 'el-icon-arrow-up'
                }
            },
            handleClick(){
                this.itemData = []
                this.tableLoading = true
                let  params = {
                    type: this.activeName || '',
                    size: 99
                }
                getSubjectDlList(params).then(res =>{
                    this.tableLoading = false;
                    // this.itemData = res.data.data.records;
                    let arr = res.data.data.records;

                    if(arr.length > 0) {
                        let newArr = arr.filter(item => {
                            return item.url;
                        })
                        // if (newArr.length > 15) {
                        //     this.itemData = newArr.slice(0, 15);
                        // } else {
                        //     this.itemData = newArr;
                        // }
                        this.itemData = newArr;
                    }
                })
            },
            goServe(item){
                window.open(item.url);
            },
            goManage(){
                let routeData = this.$router.resolve({
                    path: `/management/navlink`
                });
                window.open(routeData.href);
            }
        },
        watch: {},
        filters: {}
    }
</script>

<style lang="less">
    .module-items {
        padding: 10px 15px 0;
        background-color: #fff;
        .tab-draggable {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }
        .module-item {
            height: 100%;
            background-color: #F2F3F6;
            position: relative;
            cursor: move;
            >i {
                position: absolute;
                top: 10px;
                right: 10px;
                color: #1764A5;
                font-size: 23px;
                cursor: pointer;
            }
            &:hover {
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            }
        }
        .tab-item {
            width: 128px;
            text-align: center;
            font-size: 18px;
            line-height: 38px;
            position: relative;
            cursor: pointer;
            img {
                position: absolute;
                bottom: -7px;
                left: 50%;
                margin-left: -45px;
            }
        }
        // .serve-box {
        //   background-color: #F5F6F8;
        //   padding: 14px 50px 0;
        //   flex-wrap: wrap;
        .serve-item {
            width: 25%;
            margin: 14px 0;
            cursor: pointer;
            user-select: none;
            .serve-logo {
                text-align: center;
                img {
                    height: 60px;
                    width: 60px;
                    border-radius: 50%;
                }
            }
            .serve-name {
                text-align: center;
                font-size: 18px;
                line-height: 46px;
            }
        }
        // }
        .arrRight{
            width: 100%;
            height: 100px;
            line-height: 100px;
            text-align: center;
            font-size: 28px;
            >i {
                transform: rotate(90deg);
            }
        }
    }
    .contClas{
        ::-webkit-scrollbar {
            display: none;
        }
    }
    /*.more{*/
        /*width: 100%;*/
        /*text-align: center;*/
        /*padding: 10px;*/
        /*cursor: pointer;*/
    /*}*/
/deep/.el-tabs__nav-scroll{
    overflow-x: auto!important;
}
</style>